module.exports = __webpack_public_path__ + "media/images/emblems/GW-GR-Ferrera-b0e08856d9de6933a0ed3ac36e7192e2.png";